import type { RowData } from '@tanstack/react-table';
import type { ReactNode } from 'react';

import { useRef } from 'react';

import type { AppTable } from './Table.hooks';

import { TableScrollTargetContext } from './TableRoot.context';

export type TableProps<TData extends RowData> = {
  children: ReactNode;
  table: AppTable<TData>;
};

export const TableRoot = <TData extends RowData>({ children, table }: TableProps<TData>) => {
  const scrollTargetRef = useRef<HTMLDivElement>(null);

  return (
    <table.AppTable>
      <TableScrollTargetContext value={scrollTargetRef}>{children}</TableScrollTargetContext>
    </table.AppTable>
  );
};
